import React, { useState, useEffect } from 'react';
import Slider from '@mui/material/Slider';
import { Box, Checkbox, FormControlLabel } from '@mui/material';

const SLIDER_CONFIG = {
  one_to_ten: {
    marks: Array.from({ length: 10 }, (_, i) => ({ value: i + 1, label: `${i + 1}` })),
    min: 1,
    max: 10,
  },
  nps: {
    marks: Array.from({ length: 11 }, (_, i) => ({ value: i, label: `${i}` })),
    min: 0,
    max: 10,
  },
};

export const SliderQuestion = ({ question, answer, onAnswerChange, primaryColor, secondaryColor }) => {
  const config = SLIDER_CONFIG[question.q_type];
  const [isNA, setIsNA] = useState(answer === 'N/A');

  useEffect(() => {
    setIsNA(answer === 'N/A');
  }, [question.id]);

  if (!config) return null;

  const handleNAChange = (e) => {
    const checked = e.target.checked;
    setIsNA(checked);
    onAnswerChange(checked ? 'N/A' : '');
  };

  let handleChange, valuetext;

  if (question.q_type === 'nps') {
    handleChange = (event, value) => {
      onAnswerChange(config.marks[value].label);
    };

    valuetext = (value) => `${config.marks[value].label}`;
  } else {
    handleChange = (event, value) => {
      onAnswerChange(config.marks[value - 1].label);
    };

    valuetext = (value) => `${config.marks[value - 1].label}`;
  }

  return (
    <Box className="slider">
      <Slider
        aria-label={question.q_type}
        getAriaValueText={valuetext}
        valueLabelFormat={valuetext}
        valueLabelDisplay="on"
        value={answer && !isNaN(parseInt(answer)) ? parseInt(answer) : 1}
        step={1}
        marks={config.marks}
        min={config.min}
        max={config.max}
        disabled={isNA}
        sx={{
          color: primaryColor,
          '& .MuiSlider-thumb': {
            color: secondaryColor,
          },
        }}
        onChange={handleChange}
      />
      {!question.required && (
        <FormControlLabel
          control={
            <Checkbox
              checked={isNA}
              onChange={handleNAChange}
              sx={{
                color: '#ddd',
                '&.Mui-checked': { color: '#2aa1d3' },
              }}
            />
          }
          label="N/A"
          sx={{ mt: 1 }}
        />
      )}
    </Box>
  );
};